import $ from 'jquery';
import {gsap, Power4} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

let carouselFeatures = {
    slidesCount: 0,
    init() {
        if (!$('.carousel-features-desktop').length) return;
        $('.carousel-features-desktop').each((index, element) => {
            this.initAnimation(element);
        });
    },
    initAnimation(element) {
        const slidesCount = $(element).find('.carousel-features-desktop__item').length  + 1;
        $(element).find('.carousel-features-desktop__item:nth-child(1)').addClass('is-active');
        const timeline = gsap.timeline({
            defaults: {
                overwrite: "auto",
                ease: "power1"
            },
            scrollTrigger: {
                end: `+=${slidesCount * 50}%`,
                pin: true,
                pinSpacing: true,
                scrub: true,
                start: "top top",
                trigger: element,
                onUpdate: (self) => {
                    const progress = self.progress.toFixed(2);
                    let currentSlide = Math.round(progress * slidesCount);
                    if(currentSlide > slidesCount) currentSlide = slidesCount;
                    $(element).find('.carousel-features-desktop__item:nth-child(' + currentSlide + ')').addClass('is-active').siblings().removeClass('is-active');

                }
            }
        });

    },
}

export default carouselFeatures;